var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.30859 8.91797C5.44922 8.91797 5.58398 8.87109 5.72461 8.73047L7.6875 6.83789C7.78711 6.73828 7.8457 6.62695 7.8457 6.48633C7.8457 6.21094 7.62305 6.01172 7.35352 6.01172C7.21875 6.01172 7.08398 6.07031 6.99023 6.17578L6.16992 7.04297L5.79492 7.47656L5.85352 6.60938V0.539062C5.85352 0.246094 5.60742 0 5.30859 0C5.00391 0 4.75781 0.246094 4.75781 0.539062V6.60938L4.81641 7.47656L4.44141 7.04297L3.62109 6.17578C3.52734 6.07031 3.38672 6.01172 3.25195 6.01172C2.98242 6.01172 2.76562 6.21094 2.76562 6.48633C2.76562 6.62695 2.82422 6.73828 2.92383 6.83789L4.89258 8.73047C5.0332 8.87109 5.16211 8.91797 5.30859 8.91797ZM1.92773 12.709H8.67773C9.94922 12.709 10.6055 12.0527 10.6055 10.7988V5.03906C10.6055 3.78516 9.94922 3.12891 8.67773 3.12891H7.0957V4.29492H8.60156C9.13477 4.29492 9.43945 4.57617 9.43945 5.13867V10.6934C9.43945 11.2559 9.13477 11.5371 8.60156 11.5371H2.00391C1.46484 11.5371 1.16602 11.2559 1.16602 10.6934V5.13867C1.16602 4.57617 1.46484 4.29492 2.00391 4.29492H3.52734V3.12891H1.92773C0.662109 3.12891 0 3.7793 0 5.03906V10.7988C0 12.0527 0.662109 12.709 1.92773 12.709Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.ba9defdb72139a781e02dc341fb159ec.svg";
export { ForwardRef as ReactComponent };